var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.meta.layout && _vm.$route.meta.layout != 0)?_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"top-menu"},[_c('topMenu')],1),_c('div',{staticClass:"main"},[_c('leftMenu'),_c('contentBox',{attrs:{"left":_vm.left}})],1)]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }